/* Ensure native social-video posters are visible on mobile Safari.
   The main buy-box script adds `has-poster`; this overlay is the element
   that the corresponding CSS expects to display above the hidden video. */
(function() {
  function mountPoster(card) {
    if (!card || card.querySelector('.moby-buy-box__social-video-poster')) return;

    var video = card.querySelector('.moby-buy-box__social-video');
    if (!video) return;

    var posterUrl = video.getAttribute('poster');
    if (!posterUrl) return;

    var posterImage = document.createElement('img');
    posterImage.className = 'moby-buy-box__social-video-poster';
    posterImage.alt = '';
    posterImage.decoding = 'async';
    posterImage.setAttribute('aria-hidden', 'true');
    posterImage.addEventListener('error', function() {
      card.classList.remove('has-poster');
      posterImage.remove();
    }, { once: true });
    posterImage.src = posterUrl;

    card.insertBefore(posterImage, video);
    card.classList.add('has-poster');
  }

  document.querySelectorAll('.moby-buy-box__social-video-card').forEach(mountPoster);
})();
